<template>
  <div class="couponDialog" @touchmove.prevent>
    <!-- 优惠券单会员弹窗 -->
    <div class="singleVipCoupon" v-if="vipCouponDialogInfo.num === 1">
      <div class="dialogBox">
        <!-- 标题 -->
        <div class="title">
          温馨提示
        </div>
        <!-- 内容 -->
        <div class="info">
          当前优惠券，仅限{{
            vipCouponDialogInfo.vipList[0].name
          }}会员领取，现在去开通
        </div>
        <!-- 按钮 -->
        <div class="btnBox">
          <div class="btn1"  @click="handleLater">
            稍后
          </div>
          <div class="btn2" @click="gotoOpenVip(vipCouponDialogInfo.vipList[0].id)">
            去开通
          </div>
        </div>
      </div>
    </div>
    <!-- 优惠券多会员弹窗 -->
    <div class="multipleVipCoupon" v-if="vipCouponDialogInfo.num > 1">
      <div class="dialogBox2">
        <!-- 标题 -->
        <div class="title">
          当前优惠券仅限以下会员领取
        </div>
        <!-- 会员列表 -->
        <div class="vipList">
          <div
            class="vipItem"
            v-for="(item, index) in vipCouponDialogInfo.vipList"
            :key="index"
            @click="gotoOpenVip(item.id)"
          >
            开通{{ item.name }}会员
          </div>
        </div>
        <!-- 稍后 -->
        <div class="later" @click="handleLater">
          稍后
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['vipCouponDialogInfo'],
  name: '',
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    // 开通会员
    gotoOpenVip(id){
      console.log(id);
      this.$emit('handleOpenVip',id)
      this.$emit('changeCouponDialog',false)
    },
    // 点击稍后
    handleLater(){
      console.log('点击稍后');
      this.$emit('changeCouponDialog',false)
    }
  }
}
</script>

<style lang="less" scoped>
.couponDialog {
  width: 100vw;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  // 单会员
  .singleVipCoupon {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .dialogBox {
      width: 5.2rem;
      min-height: 3.86rem;
      background: #ffffff;
      border-radius: 0.2rem;
      .title {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.2rem;
        // border-bottom: 0.14vw solid #e5e5e5;
        text-align: center;
        font-size: 0.34rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;

      }
      .info {
        width: 4rem;
        height: 0.8rem;
        margin: 0 auto;
        margin-top: 0.27rem;
        margin-bottom: 0.48rem;
        text-align: center;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.4rem;
      }
      .btnBox {
        display: flex;
        justify-content: space-between;
        margin: 0 0.3rem 0.3rem 0.3rem;
        .btn1 {
          width: 2.2rem;
          height: 0.8rem;

          color: #222222;
          background: #f7f8fc;
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #222222;
          border-radius: 0.45rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .btn2 {
          width: 2.2rem;
          height: 0.8rem;
          background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #613f25;
          border-radius: 0.45rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  // 多会员
  .multipleVipCoupon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .dialogBox2 {
      width: 7.5rem;
      min-height: 5.48rem;
      background: #ffffff;
      border-radius: 0.2rem 0.2rem 0 0;
      position: fixed;
      bottom: 0;
      left: 0;
      // box-sizing: border-box;
      // padding-top: 0.4rem;
      .title {
        width: 100%;
        height: 1rem;
        margin: 0.4rem 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
                flex-wrap: wrap;
        div {
          display: inline-block;
        }
      }
      .vipList {
        .vipItem {
          height: 1rem;
          margin: 0 0.4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 0.14vw solid #e5e5e5;

          font-size: 0.3rem;
          color: #d8bea4;
          font-weight: 600;
        }
      }
      .later {
        height: 1rem;
        margin-bottom: 0.68rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
        font-size: 0.3rem;
        font-weight: 600;
      }
    }
  }
}
</style>
